import "core-js/modules/es.array.reduce";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function type(a) {
  var typeOf = typeof a;

  if (a === null) {
    return 'Null';
  } else if (a === undefined) {
    return 'Undefined';
  } else if (typeOf === 'boolean') {
    return 'Boolean';
  } else if (typeOf === 'number') {
    return 'Number';
  } else if (typeOf === 'string') {
    return 'String';
  } else if (Array.isArray(a)) {
    return 'Array';
  } else if (a instanceof RegExp) {
    return 'RegExp';
  }

  var asStr = a.toString();

  if (asStr.startsWith('async')) {
    return 'Async';
  } else if (asStr === '[object Promise]') {
    return 'Promise';
  } else if (asStr.includes('function') || asStr.includes('=>')) {
    return 'Function';
  }

  return 'Object';
}

function allFalse() {
  var counter = 0;

  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }

  while (counter < inputs.length) {
    var x = inputs[counter];

    if (type(x) === 'Function') {
      if (inputs[counter]()) {
        return false;
      }
    } else if (inputs[counter]) {
      return false;
    }

    counter++;
  }

  return true;
}

function allTrue() {
  var counter = 0;

  for (var _len2 = arguments.length, inputs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    inputs[_key2] = arguments[_key2];
  }

  while (counter < inputs.length) {
    var x = inputs[counter];

    if (type(x) === 'Function') {
      if (!inputs[counter]()) {
        return false;
      }
    } else if (!inputs[counter]) {
      return false;
    }

    counter++;
  }

  return true;
}

function allType(targetType) {
  return function () {
    var counter = 0;

    for (var _len3 = arguments.length, inputs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      inputs[_key3] = arguments[_key3];
    }

    while (counter < inputs.length) {
      if (type(inputs[counter]) !== targetType) {
        return false;
      }

      counter++;
    }

    return true;
  };
}

function anyFalse() {
  var counter = 0;

  for (var _len4 = arguments.length, inputs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    inputs[_key4] = arguments[_key4];
  }

  while (counter < inputs.length) {
    if (!inputs[counter]) {
      return true;
    }

    counter++;
  }

  return false;
}

function anyTrue() {
  var counter = 0;

  for (var _len5 = arguments.length, inputs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    inputs[_key5] = arguments[_key5];
  }

  while (counter < inputs.length) {
    if (inputs[counter]) {
      return true;
    }

    counter++;
  }

  return false;
}

function anyType(targetType) {
  return function () {
    var counter = 0;

    for (var _len6 = arguments.length, inputs = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      inputs[_key6] = arguments[_key6];
    }

    while (counter < inputs.length) {
      if (type(inputs[counter]) === targetType) {
        return true;
      }

      counter++;
    }

    return false;
  };
}
/**Used as the `TypeError` message for "Functions" methods. */


var FUNC_ERROR_TEXT = 'Expected a function';
/**Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;
/**`Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';
/**Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/**Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/**Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**Detect free variable `global` from Node.js. */

var freeGlobal = typeof global === 'object' && global && global.Object === Object && global;
/**Detect free variable `self`. */

var freeSelf = typeof self === 'object' && self && self.Object === Object && self;
/**Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  //Many host objects are `Object` objects that can coerce to strings
  //despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString !== 'function') {
    try {
      result = Boolean(String(value));
    } catch (e) {}
  }

  return result;
}
/**Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/**Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/**Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/**Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/**Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**Built-in value references. */

var Symbol$1 = root.Symbol,
    splice = arrayProto.splice;
/*Built-in method references that are verified to be native. */

var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');
/**Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} //Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} //Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    hash: new Hash(),
    map: new (Map || ListCache)(),
    string: new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key).delete(key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} //Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */


function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }

  path = isKey(path, object) ? [path] : castPath(path);
  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;

      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }

    assignValue(nested, key, newValue);
    nested = nested[key];
  }

  return object;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString(value) {
  //Exit early for strings to avoid a performance hit in some environments.
  if (typeof value === 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = String(value);
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */


function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key === 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */


function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return Boolean(length) && (typeof value === 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */


function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return Boolean(maskSrcKey) && maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */


var stringToPath = memoize(function (string) {
  string = toString(string);
  var result = [];

  if (reLeadingDot.test(string)) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value === 'string' || isSymbol(value)) {
    return value;
  }

  var result = String(value);
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return String(func);
    } catch (e) {}
  }

  return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */


function memoize(func, resolver) {
  if (typeof func !== 'function' || resolver && typeof resolver !== 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} //Assign cache to `_.memoize`.


memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  //The use of `Object#toString` avoids issues with the `typeof` operator
  //in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = typeof value;
  return Boolean(value) && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return Boolean(value) && typeof value === 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value === 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */


function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

function whenObject(rule, hash) {
  var yes = {};
  var no = {};
  Object.entries(hash).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        prop = _ref2[0],
        value = _ref2[1];

    if (rule(value, prop)) {
      yes[prop] = value;
    } else {
      no[prop] = value;
    }
  });
  return [yes, no];
}

function partition(rule, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return partition(rule, listHolder);
    };
  }

  if (!Array.isArray(list)) return whenObject(rule, list);
  var yes = [];
  var no = [];
  var counter = -1;

  while (counter++ < list.length - 1) {
    if (rule(list[counter], counter)) {
      yes.push(list[counter]);
    } else {
      no.push(list[counter]);
    }
  }

  return [yes, no];
} //Its lodash's set method taken from


var isObject$1 = function isObject$1(x) {
  var ok = x !== null && !Array.isArray(x) && typeof x === 'object';

  if (!ok) {
    return false;
  }

  return Object.keys(x).length > 0;
};

function change(origin, pathRaw, rules) {
  var willReturn = JSON.parse(JSON.stringify(origin));

  if (!isObject$1(rules)) {
    set(willReturn, pathRaw, rules);
    return willReturn;
  }

  var path = pathRaw === '' ? '' : "".concat(pathRaw, ".");

  var _loop = function _loop() {
    var ruleKey = _Object$keys[_i];
    var rule = rules[ruleKey];

    if (!isObject$1(rule)) {
      set(willReturn, "".concat(path).concat(ruleKey), rule);
      return "continue";
    }

    var _partition = partition(function (subruleKey) {
      return isObject$1(rule[subruleKey]);
    }, Object.keys(rule)),
        _partition2 = _slicedToArray(_partition, 2),
        withObjects = _partition2[0],
        withoutObjects = _partition2[1];

    withoutObjects.forEach(function (subruleKey) {
      var subrule = rule[subruleKey];
      set(willReturn, "".concat(path).concat(ruleKey, ".").concat(subruleKey), subrule);
    });
    withObjects.forEach(function (subruleKey) {
      var subrule = rule[subruleKey];
      Object.keys(subrule).forEach(function (deepKey) {
        var deep = rule[subruleKey][deepKey];

        if (!isObject$1(deep)) {
          return set(willReturn, "".concat(path).concat(ruleKey, ".").concat(subruleKey, ".").concat(deepKey), deep);
        }

        Object.keys(deep).forEach(function (superDeepKey) {
          var superDeep = rule[subruleKey][deepKey][superDeepKey];
          set(willReturn, "".concat(path).concat(ruleKey, ".").concat(subruleKey, ".").concat(deepKey, ".").concat(superDeepKey), superDeep);
        });
      });
    });
  };

  for (var _i = 0, _Object$keys = Object.keys(rules); _i < _Object$keys.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return willReturn;
}

function equals(a, b) {
  if (arguments.length === 1) {
    return function (bHolder) {
      return equals(a, bHolder);
    };
  }

  if (a === b) {
    return true;
  }

  var aType = type(a);

  if (aType !== type(b)) {
    return false;
  }

  if (aType === 'Array') {
    var aClone = Array.from(a);
    var bClone = Array.from(b);

    if (aClone.toString() !== bClone.toString()) {
      return false;
    }

    var loopArrayFlag = true;
    aClone.forEach(function (aCloneInstance, aCloneIndex) {
      if (loopArrayFlag) {
        if (aCloneInstance !== bClone[aCloneIndex] && !equals(aCloneInstance, bClone[aCloneIndex])) {
          loopArrayFlag = false;
        }
      }
    });
    return loopArrayFlag;
  }

  if (aType === 'Object') {
    var aKeys = Object.keys(a);

    if (aKeys.length !== Object.keys(b).length) {
      return false;
    }

    var loopObjectFlag = true;
    aKeys.forEach(function (aKeyInstance) {
      if (loopObjectFlag) {
        var aValue = a[aKeyInstance];
        var bValue = b[aKeyInstance];

        if (aValue !== bValue && !equals(aValue, bValue)) {
          loopObjectFlag = false;
        }
      }
    });
    return loopObjectFlag;
  }

  return false;
}

var forbidden = ['Null', 'Undefined', 'RegExp'];
var allowed = ['Number', 'Boolean'];
var notEmpty = ['Array', 'String'];

function compact(arr) {
  var willReturn = [];
  arr.forEach(function (a) {
    var currentType = type(a);
    if (forbidden.includes(currentType)) return;
    if (allowed.includes(currentType)) return willReturn.push(a);

    if (currentType === 'Object') {
      if (!equals(a, {})) willReturn.push(a);
      return;
    }

    if (!notEmpty.includes(currentType)) return;
    if (a.length === 0) return;
    willReturn.push(a);
  });
  return willReturn;
}

function composeAsync() {
  for (var _len7 = arguments.length, inputArguments = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    inputArguments[_key7] = arguments[_key7];
  }

  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startArgument) {
      var argumentsToPass, fn, typeFn;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              argumentsToPass = startArgument;

            case 1:
              if (!(inputArguments.length !== 0)) {
                _context.next = 13;
                break;
              }

              fn = inputArguments.pop();
              typeFn = type(fn);

              if (!(typeFn === 'Async')) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return fn(argumentsToPass);

            case 7:
              argumentsToPass = _context.sent;
              _context.next = 11;
              break;

            case 10:
              argumentsToPass = fn(argumentsToPass);

            case 11:
              _context.next = 1;
              break;

            case 13:
              return _context.abrupt("return", argumentsToPass);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function compose() {
  for (var _len8 = arguments.length, fns = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    fns[_key8] = arguments[_key8];
  }

  return function () {
    var list = fns.slice();

    if (list.length > 0) {
      var fn = list.pop();
      var result = fn.apply(void 0, arguments);

      while (list.length > 0) {
        result = list.pop()(result);
      }

      return result;
    }

    return undefined;
  };
}

function last(a) {
  if (typeof a === 'string') {
    return a[a.length - 1] || '';
  }

  return a[a.length - 1];
}

function baseSlice(array, start, end) {
  var index = -1;
  var length = array.length;
  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

function init(a) {
  if (typeof a === 'string') {
    return a.slice(0, -1);
  }

  return a.length ? baseSlice(a, 0, -1) : [];
}

function composed() {
  for (var _len9 = arguments.length, inputs = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    inputs[_key9] = arguments[_key9];
  }

  return compose.apply(void 0, _toConsumableArray(init(inputs)))(last(inputs));
}

function count(target, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return count(target, listHolder);
    };
  }

  if (!Array.isArray(list)) return 0;
  return list.filter(function (x) {
    return equals(x, target);
  }).length;
}

function debounce(func, ms) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout;
  return function () {
    for (var _len10 = arguments.length, input = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      input[_key10] = arguments[_key10];
    }

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(null, input);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, ms);

    if (callNow) {
      func.apply(null, input);
    }
  };
}

function flagIs(targetType, input) {
  if (!input) return false;
  if (type(input) !== targetType) return false;
  if (targetType === 'Array') return !equals([], input);
  if (targetType === 'Object') return !equals({}, input);
  return true;
}

function defaultToStrict(defaultArgument) {
  for (var _len11 = arguments.length, inputArguments = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
    inputArguments[_key11 - 1] = arguments[_key11];
  }

  if (arguments.length === 1) {
    return function (inputArgumentsHolder) {
      return defaultToStrict(defaultArgument, inputArgumentsHolder);
    };
  }

  if (arguments.length === 2) {
    return flagIs(type(defaultArgument), inputArguments[0]) ? inputArguments[0] : defaultArgument;
  }

  var targetType = type(defaultArgument);
  var limit = inputArguments.length - 1;
  var len = limit + 1;
  var ready = false;
  var holder;

  while (!ready) {
    var instance = inputArguments[limit - len + 1];

    if (len === 0) {
      ready = true;
    } else if (flagIs(targetType, instance)) {
      holder = instance;
      ready = true;
    } else {
      len -= 1;
    }
  }

  return holder === undefined ? defaultArgument : holder;
}

function defaultToWhen(defaultArgument, fn) {
  for (var _len12 = arguments.length, inputArguments = new Array(_len12 > 2 ? _len12 - 2 : 0), _key12 = 2; _key12 < _len12; _key12++) {
    inputArguments[_key12 - 2] = arguments[_key12];
  }

  if (arguments.length === 2) {
    return function () {
      for (var _len13 = arguments.length, inputArgumentsHolder = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        inputArgumentsHolder[_key13] = arguments[_key13];
      }

      return defaultToWhen.apply(void 0, [defaultArgument, fn].concat(inputArgumentsHolder));
    };
  }

  var limit = inputArguments.length - 1;
  var len = limit + 1;
  var ready = false;
  var holder;

  while (!ready) {
    var instance = inputArguments[limit - len + 1];

    if (len === 0) {
      ready = true;
    } else if (fn(instance) === true) {
      holder = instance;
      ready = true;
    } else {
      len = len - 1;
    }
  }

  return holder === undefined ? defaultArgument : holder;
}

function delay(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve('RAMBDAX_DELAY');
    }, ms);
  });
}

function findInObject(fn, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return findInObject(fn, objHolder);
    };
  }

  var willReturn = {
    fallback: true
  };
  Object.entries(obj).forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        prop = _ref5[0],
        value = _ref5[1];

    if (willReturn.fallback) {
      if (fn(value, prop)) {
        willReturn = {
          prop: prop,
          value: value
        };
      }
    }
  });
  return willReturn;
} //WAIT


function findModify(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return findModify(fn, listHolder);
    };
  }

  var len = list.length;
  if (len === 0) return false;
  var index = -1;

  while (++index < len) {
    var result = fn(list[index], index);

    if (result !== false) {
      return result;
    }
  }

  return false;
}

function flatMap(fn, xs) {
  var _ref6;

  if (arguments.length === 1) {
    return function (xsHolder) {
      return flatMap(fn, xsHolder);
    };
  }

  return (_ref6 = []).concat.apply(_ref6, _toConsumableArray(xs.map(fn)));
}

function pick(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return pick(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};
  var counter = 0;

  while (counter < keysValue.length) {
    if (keysValue[counter] in obj) {
      willReturn[keysValue[counter]] = obj[keysValue[counter]];
    }

    counter++;
  }

  return willReturn;
}

function merge(obj, newProps) {
  if (arguments.length === 1) {
    return function (newPropsHolder) {
      return merge(obj, newPropsHolder);
    };
  }

  return Object.assign({}, obj || {}, newProps || {});
}

var holder = {};
/**
 * Pass string to get value
 * Pass array to get object of values
 * Pass undefined to get all data
 */

function getter(key) {
  var typeKey = type(key);
  if (typeKey === 'String') return holder[key];
  if (typeKey === 'Array') return pick(key, holder);
  return holder;
}

function setter(maybeKey, maybeValue) {
  var typeKey = type(maybeKey);
  var typeValue = type(maybeValue);

  if (typeKey === 'String') {
    if (typeValue === 'Function') {
      return holder[maybeKey] = maybeValue(holder[maybeKey]);
    }

    return holder[maybeKey] = maybeValue;
  }

  if (typeKey !== 'Object') return;
  holder = merge(holder, maybeKey);
}

function reset() {
  holder = {};
}

function glue(input, glue) {
  return input.split('\n').filter(function (x) {
    return x.trim().length > 0;
  }).map(function (x) {
    return x.trim();
  }).join(glue !== undefined ? glue : ' ');
}

function path(pathArr, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return path(pathArr, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var willReturn = obj;
  var counter = 0;
  var pathArrValue = typeof pathArr === 'string' ? pathArr.split('.') : pathArr;

  while (counter < pathArrValue.length) {
    if (willReturn === null || willReturn === undefined) {
      return undefined;
    }

    willReturn = willReturn[pathArrValue[counter]];
    counter++;
  }

  return willReturn;
}

function hasPath(maybePath, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return hasPath(maybePath, objHolder);
    };
  }

  return path(maybePath, obj) !== undefined;
}

function headObject(input) {
  var _Object$entries = Object.entries(input),
      _Object$entries2 = _slicedToArray(_Object$entries, 2),
      head = _Object$entries2[0],
      _ = _Object$entries2[1];

  if (!head) return {
    prop: undefined,
    value: undefined
  };
  if (_) throw new Error('R.headObject expects object with only one key');
  return {
    prop: head[0],
    value: head[1]
  };
}

function createThenable(x) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", x(input));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function ifElseAsync(condition, ifFn, elseFn) {
  return function (input) {
    return new Promise(function (resolve, reject) {
      var conditionPromise = createThenable(condition);
      var ifFnPromise = createThenable(ifFn);
      var elseFnPromise = createThenable(elseFn);
      conditionPromise(input).then(function (conditionResult) {
        var promised = conditionResult === true ? ifFnPromise : elseFnPromise;
        promised(input).then(resolve).catch(reject);
      }).catch(reject);
    });
  };
}

function any(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return any(fn, arrHolder);
    };
  }

  var counter = 0;

  while (counter < arr.length) {
    if (fn(arr[counter], counter)) {
      return true;
    }

    counter++;
  }

  return false;
}

function expensiveIncludes(target, source) {
  return any(function (singleSource) {
    return equals(target, singleSource);
  }, source);
}

function includesAny(targets, source) {
  if (arguments.length === 1) {
    return function (sourceHolder) {
      return includesAny(targets, sourceHolder);
    };
  }

  var sourceType = type(source);

  if (['Array', 'String'].includes(sourceType) === false) {
    return false;
  }

  if (sourceType === 'String') {
    return any(function (x) {
      return source.includes(x);
    }, targets);
  }

  return any(function (x) {
    return expensiveIncludes(x, source);
  }, targets);
}

function includesType(targetType, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return includesType(targetType, listHolder);
    };
  }

  return any(function (x) {
    return type(x) === targetType;
  }, list);
}

function replace(regex, replacer, str) {
  if (replacer === undefined) {
    return function (replacerHolder, strHolder) {
      return replace(regex, replacerHolder, strHolder);
    };
  } else if (str === undefined) {
    return function (strHolder) {
      return replace(regex, replacer, strHolder);
    };
  }

  return str.replace(regex, replacer);
}

function inject(injection, marker, content) {
  return replace(marker, "".concat(marker).concat(injection), content);
}

function take(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return take(num, xHolder);
  };

  if (typeof x === 'string') {
    return x.slice(0, num);
  }

  return baseSlice(x, 0, num);
}

function shuffle(arrayRaw) {
  var array = arrayRaw.concat();
  var counter = array.length;

  while (counter > 0) {
    var index = Math.floor(Math.random() * counter);
    counter--;
    var temp = array[counter];
    array[counter] = array[index];
    array[index] = temp;
  }

  return array;
}

var uuidList = '0123456789qwertyuiopasdfghjklzxcvbnm'.split('');

function uuid() {
  return take(5, shuffle(uuidList).join(''));
}

var holder$1 = {};

function interval(_ref8) {
  var fn = _ref8.fn,
      ms = _ref8.ms,
      whenStop = _ref8.whenStop;
  var key = uuid();
  return new Promise(function (resolve) {
    holder$1[key] = setInterval(function () {
      if (whenStop() === true) {
        clearInterval(holder$1[key]);
        resolve();
      } else {
        fn();
      }
    }, ms);
  });
}

function toLower(x) {
  return x.toLowerCase();
}

function contains(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return contains(x, arrHolder);
    };
  }

  var index = -1;
  var flag = false;

  while (++index < arr.length && !flag) {
    if (equals(arr[index], x)) {
      flag = true;
    }
  }

  return flag;
}

function test$1(regex, str) {
  if (arguments.length === 1) return function (strHolder) {
    return test$1(regex, strHolder);
  };
  return str.search(regex) !== -1;
}

function filterObject(fn, obj) {
  var willReturn = {};

  for (var _prop in obj) {
    if (fn(obj[_prop], _prop)) {
      willReturn[_prop] = obj[_prop];
    }
  }

  return willReturn;
}

function filter(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return filter(fn, arrHolder);
    };
  }

  if (arr === undefined) {
    return [];
  }

  if (!Array.isArray(arr)) {
    return filterObject(fn, arr);
  }

  var index = -1;
  var resIndex = 0;
  var len = arr.length;
  var willReturn = [];

  while (++index < len) {
    var value = arr[index];

    if (fn(value, index)) {
      willReturn[resIndex++] = value;
    }
  }

  return willReturn;
}

function all(condition, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return all(condition, arrHolder);
    };
  }

  return filter(condition, arr).length === arr.length;
}

function fromPrototypeToString(rule, ruleType) {
  if (ruleType !== 'Function') return {
    rule: rule,
    parsed: false
  };

  if (typeof rule.prototype === 'function' || rule.prototype === undefined) {
    return {
      rule: rule,
      parsed: false
    };
  }

  if (String.prototype === rule.prototype) {
    return {
      rule: 'string',
      parsed: true
    };
  }

  if (Boolean.prototype === rule.prototype) {
    return {
      rule: 'boolean',
      parsed: true
    };
  }

  if (Number.prototype === rule.prototype) {
    return {
      rule: 'number',
      parsed: true
    };
  }

  return {
    rule: type(rule.prototype).toLowerCase(),
    parsed: true
  };
}

function getRuleAndType(schema, requirementRaw) {
  var ruleRaw = schema[requirementRaw];
  var typeIs = type(ruleRaw);

  var _fromPrototypeToStrin = fromPrototypeToString(ruleRaw, typeIs),
      rule = _fromPrototypeToStrin.rule,
      parsed = _fromPrototypeToStrin.parsed;

  return {
    rule: rule,
    ruleType: parsed ? 'String' : typeIs
  };
}

function isValid(_ref9) {
  var input = _ref9.input,
      schema = _ref9.schema;
  if (input === undefined || schema === undefined) return false;
  var flag = true;

  var boom = function boom(boomFlag) {
    if (!boomFlag) {
      flag = false;
    }
  };

  for (var requirementRaw in schema) {
    if (flag) {
      var isOptional = requirementRaw.endsWith('?');
      var requirement = isOptional ? init(requirementRaw) : requirementRaw;

      var _getRuleAndType = getRuleAndType(schema, requirementRaw),
          rule = _getRuleAndType.rule,
          ruleType = _getRuleAndType.ruleType;

      var inputProp = input[requirement];
      var inputPropType = type(input[requirement]);

      var _ok = isOptional && inputProp !== undefined || !isOptional;

      if (!_ok || rule === 'any' && inputProp != null || rule === inputProp) continue;

      if (ruleType === 'Object') {
        /**
         * This rule is standalone schema, so we recursevly call `isValid`
         */
        var isValidResult = isValid({
          input: inputProp,
          schema: rule
        });
        boom(isValidResult);
      } else if (ruleType === 'String') {
        /**
         * Rule is actual rule such as 'number', so the two types are compared
         */
        boom(toLower(inputPropType) === rule);
      } else if (typeof rule === 'function') {
        /**
         * Rule is function so we pass to it the input
         */
        boom(rule(inputProp));
      } else if (ruleType === 'Array' && inputPropType === 'String') {
        /**
         * Enum case | rule is like a: ['foo', 'bar']
         */
        boom(contains(inputProp, rule));
      } else if (ruleType === 'Array' && rule.length === 1 && inputPropType === 'Array') {
        (function () {
          /**
           * 1. array of type | rule is like a: ['number']
           * 2. rule is like a: [{from: 'string'}]
           */
          var currentRule = rule[0];
          var currentRuleType = type(rule[0]); //Check if rule is invalid

          boom(currentRuleType === 'String' || currentRuleType === 'Object');

          if (currentRuleType === 'String') {
            /**
             * 1. array of type
             */
            var isInvalidResult = any(function (inputPropInstance) {
              return type(inputPropInstance).toLowerCase() !== currentRule;
            }, inputProp);
            boom(!isInvalidResult);
          }

          if (currentRuleType === 'Object') {
            /**
             * 2. rule is like a: [{from: 'string'}]
             */
            var _isValidResult = all(function (inputPropInstance) {
              return isValid({
                input: inputPropInstance,
                schema: currentRule
              });
            }, inputProp);

            boom(_isValidResult);
          }
        })();
      } else if (ruleType === 'RegExp' && inputPropType === 'String') {
        boom(test$1(rule, inputProp));
      } else {
        boom(false);
      }
    }
  }

  return flag;
}

function isAttach() {
  if (Object.prototype.is !== undefined) {
    return false;
  }

  Object.defineProperty(Object.prototype, 'is', {
    value: function value(schema) {
      return isValid({
        input: {
          isProp: this
        },
        schema: {
          isProp: schema
        }
      });
    },
    writable: true,
    configurable: true
  });
  return true;
}

function isFunction$1(fn) {
  return ['Async', 'Promise', 'Function'].includes(type(fn));
}

function isFalsy(x) {
  var typeIs = type(x);
  if (['Array', 'String'].includes(typeIs)) return x.length === 0;
  if (typeIs === 'Object') return Object.keys(x).length === 0;
  if (['Null', 'Undefined'].includes(typeIs)) return true;
  return false;
}

function isPromise(x) {
  return ['Async', 'Promise'].includes(type(x));
}

function isType(xType, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return isType(xType, xHolder);
    };
  }

  return type(x) === xType;
}

function mapAsyncFn(_x3, _x4) {
  return _mapAsyncFn.apply(this, arguments);
}

function _mapAsyncFn() {
  _mapAsyncFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(fn, arr) {
    var _willReturn, _iterator4, _step4, a, willReturn, _prop9;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!Array.isArray(arr)) {
              _context8.next = 23;
              break;
            }

            _willReturn = [];
            _iterator4 = _createForOfIteratorHelper(arr);
            _context8.prev = 3;

            _iterator4.s();

          case 5:
            if ((_step4 = _iterator4.n()).done) {
              _context8.next = 14;
              break;
            }

            a = _step4.value;
            _context8.t0 = _willReturn;
            _context8.next = 10;
            return fn(a);

          case 10:
            _context8.t1 = _context8.sent;

            _context8.t0.push.call(_context8.t0, _context8.t1);

          case 12:
            _context8.next = 5;
            break;

          case 14:
            _context8.next = 19;
            break;

          case 16:
            _context8.prev = 16;
            _context8.t2 = _context8["catch"](3);

            _iterator4.e(_context8.t2);

          case 19:
            _context8.prev = 19;

            _iterator4.f();

            return _context8.finish(19);

          case 22:
            return _context8.abrupt("return", _willReturn);

          case 23:
            willReturn = {};
            _context8.t3 = _regeneratorRuntime.keys(arr);

          case 25:
            if ((_context8.t4 = _context8.t3()).done) {
              _context8.next = 32;
              break;
            }

            _prop9 = _context8.t4.value;
            _context8.next = 29;
            return fn(arr[_prop9], _prop9);

          case 29:
            willReturn[_prop9] = _context8.sent;
            _context8.next = 25;
            break;

          case 32:
            return _context8.abrupt("return", willReturn);

          case 33:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[3, 16, 19, 22]]);
  }));
  return _mapAsyncFn.apply(this, arguments);
}

function mapAsync(fn, arr) {
  if (arguments.length === 1) {
    return /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(holder) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", mapAsyncFn(fn, holder));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5) {
        return _ref10.apply(this, arguments);
      };
    }();
  }

  return new Promise(function (resolve, reject) {
    mapAsyncFn(fn, arr).then(resolve).catch(reject);
  });
}

function mapFastAsyncFn(_x6, _x7) {
  return _mapFastAsyncFn.apply(this, arguments);
}

function _mapFastAsyncFn() {
  _mapFastAsyncFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(fn, arr) {
    var promised;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            promised = arr.map(function (a) {
              return fn(a);
            });
            _context9.next = 3;
            return Promise.all(promised);

          case 3:
            return _context9.abrupt("return", _context9.sent);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _mapFastAsyncFn.apply(this, arguments);
}

function mapFastAsync(fn, arr) {
  if (arguments.length === 1) {
    return /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(holder) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", mapFastAsyncFn(fn, holder));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x8) {
        return _ref11.apply(this, arguments);
      };
    }();
  }

  return new Promise(function (resolve, reject) {
    mapFastAsyncFn(fn, arr).then(resolve).catch(reject);
  });
}

function mapObject(fn, obj) {
  var willReturn = {};

  for (var _prop2 in obj) {
    willReturn[_prop2] = fn(obj[_prop2], _prop2);
  }

  return willReturn;
}

function map(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return map(fn, arrHolder);
    };
  }

  if (arr === undefined) {
    return [];
  }

  if (!Array.isArray(arr)) {
    return mapObject(fn, arr);
  }

  var index = -1;
  var len = arr.length;
  var willReturn = Array(len);

  while (++index < len) {
    willReturn[index] = fn(arr[index], index);
  }

  return willReturn;
}

function mergeAll(arr) {
  var willReturn = {};
  map(function (val) {
    willReturn = merge(willReturn, val);
  }, arr);
  return willReturn;
}

function check(singleInput, schema) {
  return isValid({
    input: {
      singleInput: singleInput
    },
    schema: {
      singleInput: schema
    }
  });
}

function ok() {
  for (var _len14 = arguments.length, inputs = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    inputs[_key14] = arguments[_key14];
  }

  return function () {
    for (var _len15 = arguments.length, schemas = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      schemas[_key15] = arguments[_key15];
    }

    var failedSchema;
    var pass = any(function (singleInput, i) {
      var schema = schemas[i] === undefined ? schemas[0] : schemas[i];
      var checked = check(singleInput, schema);

      if (!checked) {
        failedSchema = JSON.stringify({
          input: singleInput,
          schema: schema
        });
      }

      return !checked;
    }, inputs) === false;
    if (!pass) throw new Error("Failed R.ok with schema ".concat(failedSchema));
    return true;
  };
}

function mapToObject(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return mapToObject(fn, listHolder);
    };
  }

  ok(type(fn), type(list))('Function', 'Array');
  return mergeAll(map(fn, list));
}

function maybe(ifRule, whenIfRaw, whenElseRaw) {
  var whenIf = ifRule && type(whenIfRaw) === 'Function' ? whenIfRaw() : whenIfRaw;
  var whenElse = !ifRule && type(whenElseRaw) === 'Function' ? whenElseRaw() : whenElseRaw;
  return ifRule ? whenIf : whenElse;
}

function sort(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return sort(fn, arrHolder);
  };
  var arrClone = arr.concat();
  return arrClone.sort(fn);
}

var cache = {};

var normalizeObject = function normalizeObject(obj) {
  var sortFn = function sortFn(a, b) {
    return a > b;
  };

  var willReturn = {};
  compose(map(function (prop) {
    return willReturn[prop] = obj[prop];
  }), sort(sortFn))(Object.keys(obj));
  return willReturn;
};

var stringify = function stringify(a) {
  if (type(a) === 'String') {
    return a;
  } else if (['Function', 'Async'].includes(type(a))) {
    var compacted = replace(/\s{1,}/g, ' ', a.toString());
    return replace(/\s/g, '_', take(15, compacted));
  } else if (type(a) === 'Object') {
    a = normalizeObject(a);
  }

  return JSON.stringify(a);
};

var generateProp = function generateProp(fn) {
  var propString = '';

  for (var _len16 = arguments.length, inputArguments = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
    inputArguments[_key16 - 1] = arguments[_key16];
  }

  inputArguments.forEach(function (inputArgument) {
    propString += "".concat(stringify(inputArgument), "_");
  });
  return "".concat(propString).concat(stringify(fn));
};

function memoize$1(fn) {
  for (var _len17 = arguments.length, inputArguments = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
    inputArguments[_key17 - 1] = arguments[_key17];
  }

  if (arguments.length === 1) {
    return function () {
      for (var _len18 = arguments.length, inputArgumentsHolder = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        inputArgumentsHolder[_key18] = arguments[_key18];
      }

      return memoize$1.apply(void 0, [fn].concat(inputArgumentsHolder));
    };
  }

  var prop = generateProp.apply(void 0, [fn].concat(inputArguments));
  if (prop in cache) return cache[prop];

  if (type(fn) === 'Async') {
    return new Promise(function (resolve) {
      fn.apply(void 0, inputArguments).then(function (result) {
        cache[prop] = result;
        resolve(result);
      });
    });
  }

  var result = fn.apply(void 0, inputArguments);
  cache[prop] = result;
  return result;
}

function mergeRight(x, y) {
  return merge(y, x);
}

function mergeDeep(target, source) {
  if (arguments.length === 1) {
    return function (sourceHolder) {
      return mergeDeep(target, sourceHolder);
    };
  }

  var willReturn = JSON.parse(JSON.stringify(target));
  Object.keys(source).forEach(function (key) {
    if (type(source[key]) === 'Object') {
      if (type(target[key]) === 'Object') {
        willReturn[key] = mergeDeep(target[key], source[key]);
      } else {
        willReturn[key] = source[key];
      }
    } else {
      willReturn[key] = source[key];
    }
  });
  return willReturn;
}

function nextIndex(index, list) {
  var newIndex = index === list.length - 1 ? 0 : index + 1;
  return newIndex;
}

function pass() {
  for (var _len19 = arguments.length, inputs = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    inputs[_key19] = arguments[_key19];
  }

  return function () {
    for (var _len20 = arguments.length, schemas = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      schemas[_key20] = arguments[_key20];
    }

    return any(function (x, i) {
      var schema = schemas[i] === undefined ? schemas[0] : schemas[i];
      return !check(x, schema);
    }, inputs) === false;
  };
} //taken from the last comment of https://gist.github.com/mkuklis/5294248


function curry(f) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function () {
    for (var _len21 = arguments.length, p = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      p[_key21] = arguments[_key21];
    }

    return function (o) {
      return o.length >= f.length ? f.apply(void 0, _toConsumableArray(o)) : curry(f, o);
    }([].concat(_toConsumableArray(a), p));
  };
}

function onceFn(fn, context) {
  var result;
  return function () {
    if (fn) {
      result = fn.apply(context || this, arguments);
      fn = null;
    }

    return result;
  };
}

function once(fn, context) {
  if (arguments.length === 1) {
    var wrap = onceFn(fn, context);
    return curry(wrap);
  }

  return onceFn(fn, context);
}

function otherwise(fallback, toResolve) {
  if (arguments.length === 1) {
    return function (toResolveHolder) {
      return otherwise(fallback, toResolveHolder);
    };
  }

  return new Promise(function (resolve) {
    toResolve.then(resolve).catch(function (e) {
      return resolve(fallback(e));
    });
  });
}

function pathEq(path$$1, target, obj) {
  if (arguments.length === 2) {
    return function (objHolder) {
      return pathEq(path$$1, target, objHolder);
    };
  }

  return path(path$$1, obj) === target;
}

function pipe() {
  for (var _len22 = arguments.length, fns = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    fns[_key22] = arguments[_key22];
  }

  return compose.apply(void 0, _toConsumableArray(fns.reverse()));
}

function piped() {
  for (var _len23 = arguments.length, inputs = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    inputs[_key23] = arguments[_key23];
  }

  var input = inputs[0],
      fnList = inputs.slice(1);
  return pipe.apply(void 0, _toConsumableArray(fnList))(input);
}

function pipedAsync() {
  return _pipedAsync.apply(this, arguments);
}

function _pipedAsync() {
  _pipedAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var _len24,
        inputs,
        _key24,
        input,
        fnList,
        argumentsToPass,
        fn,
        typeFn,
        _args10 = arguments;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            for (_len24 = _args10.length, inputs = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
              inputs[_key24] = _args10[_key24];
            }

            input = inputs[0], fnList = inputs.slice(1);
            argumentsToPass = input;

          case 3:
            if (!(fnList.length !== 0)) {
              _context10.next = 15;
              break;
            }

            fn = fnList.shift();
            typeFn = type(fn);

            if (!(typeFn === 'Async')) {
              _context10.next = 12;
              break;
            }

            _context10.next = 9;
            return fn(argumentsToPass);

          case 9:
            argumentsToPass = _context10.sent;
            _context10.next = 13;
            break;

          case 12:
            argumentsToPass = fn(argumentsToPass);

          case 13:
            _context10.next = 3;
            break;

          case 15:
            return _context10.abrupt("return", argumentsToPass);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _pipedAsync.apply(this, arguments);
}

function helper(_ref12) {
  var condition = _ref12.condition,
      inputArgument = _ref12.inputArgument,
      prop = _ref12.prop;
  return new Promise(function (resolve, reject) {
    if (!(type(condition) === 'Async')) {
      return resolve({
        type: prop,
        payload: condition(inputArgument)
      });
    }

    condition(inputArgument).then(function (result) {
      resolve({
        type: prop,
        payload: result
      });
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function produce(conditions, inputArgument) {
  if (arguments.length === 1) {
    return function (inputArgumentHolder) {
      return produce(conditions, inputArgumentHolder);
    };
  }

  var asyncConditionsFlag = false;

  for (var _prop3 in conditions) {
    if (asyncConditionsFlag === false && type(conditions[_prop3]) === 'Async') {
      asyncConditionsFlag = true;
    }
  }

  if (asyncConditionsFlag === false) {
    var willReturn = {};

    for (var _prop4 in conditions) {
      willReturn[_prop4] = conditions[_prop4](inputArgument);
    }

    return willReturn;
  }

  var promised = [];

  for (var _prop5 in conditions) {
    var condition = conditions[_prop5];
    promised.push(helper({
      inputArgument: inputArgument,
      condition: condition,
      prop: _prop5
    }));
  }

  return new Promise(function (resolve, reject) {
    Promise.all(promised).then(function (results) {
      var willReturn = {};
      map(function (result) {
        return willReturn[result.type] = result.payload;
      }, results);
      resolve(willReturn);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function promiseAllObject(promises) {
  return new Promise(function (res, rej) {
    var counter = 0;
    var props = {};
    var promisedArr = [];

    for (var _prop6 in promises) {
      props[counter] = _prop6;
      promisedArr.push(promises[_prop6]);
      counter++;
    }

    Promise.all(promisedArr).then(function (result) {
      var willReturn = {};
      result.map(function (val, key) {
        var prop = props[key];
        willReturn[prop] = val;
      });
      res(willReturn);
    }).catch(rej);
  });
}

function pushUniq(x, list) {
  if (list.includes(x)) return;
  list.push(x);
}

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function remove(inputs, text) {
  if (arguments.length === 1) {
    return function (textHolder) {
      return remove(inputs, textHolder);
    };
  }

  if (type(text) !== 'String') {
    throw new Error("R.remove requires string not ".concat(type(text)));
  }

  if (type(inputs) !== 'Array') {
    return replace(inputs, '', text).trim();
  }

  var textCopy = text;
  inputs.forEach(function (singleInput) {
    textCopy = replace(singleInput, '', textCopy).trim();
  });
  return textCopy;
}

function omit(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return omit(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};

  for (var key in obj) {
    if (!keysValue.includes(key)) {
      willReturn[key] = obj[key];
    }
  }

  return willReturn;
}

function renameProps(conditions, inputObject) {
  if (inputObject === undefined) {
    return function (inputObjectHolder) {
      return renameProps(conditions, inputObjectHolder);
    };
  }

  var renamed = {};
  Object.keys(conditions).forEach(function (renameConditionProp) {
    if (Object.keys(inputObject).includes(renameConditionProp)) {
      renamed[conditions[renameConditionProp]] = inputObject[renameConditionProp];
    }
  });
  return merge(renamed, omit(Object.keys(conditions), inputObject));
}

function resolve(afterResolve, toResolve) {
  if (arguments.length === 1) {
    return function (toResolveHolder) {
      return resolve(afterResolve, toResolveHolder);
    };
  }

  return new Promise(function (res) {
    toResolve.then(function (result) {
      return res(afterResolve(result));
    });
  });
}

var getOccurances = function getOccurances(input) {
  return input.match(/{{[_a-zA-Z0-9]+}}/g);
};

var getOccuranceProp = function getOccuranceProp(occurance) {
  return occurance.replace(/{{|}}/g, '');
};

var replace$1 = function replace$1(_ref13) {
  var inputHolder = _ref13.inputHolder,
      prop = _ref13.prop,
      replacer = _ref13.replacer;
  return inputHolder.replace("{{".concat(prop, "}}"), replacer);
};

function template(input, templateInput) {
  if (arguments.length === 1) {
    return function (templateInputHolder) {
      return template(input, templateInputHolder);
    };
  }

  var occurances = getOccurances(input);
  if (occurances === null) return input;
  var inputHolder = input;

  var _iterator = _createForOfIteratorHelper(occurances),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var occurance = _step.value;

      var _prop7 = getOccuranceProp(occurance);

      var replacer = templateInput[_prop7];
      if (replacer === undefined) continue;
      inputHolder = replace$1({
        inputHolder: inputHolder,
        prop: _prop7,
        replacer: replacer
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return inputHolder;
}

function headObject$1(x) {
  if (type(x) !== 'Object') throw new Error('R.headObject.type');

  var _Object$keys2 = Object.keys(x),
      _Object$keys3 = _slicedToArray(_Object$keys2, 2),
      tag = _Object$keys3[0],
      no = _Object$keys3[1];

  if (tag === undefined) throw new Error('R.headObject.less');
  if (no !== undefined) throw new Error('R.headObject.more');
  return {
    prop: tag,
    value: x[tag]
  };
}

var evaluationsSchema = {
  label: 'string'
};

function runTests(input) {
  var pass$$1 = pass(input)({
    testSuite: 'string',
    evaluations: [evaluationsSchema]
  });

  if (describe === undefined || !pass$$1) {
    throw new Error('R.runTests.init');
  }

  try {
    var testSuite = input.testSuite,
        evaluations = input.evaluations,
        data = input.data;
    describe(testSuite, function () {
      evaluations.forEach(function (singleEvaluation) {
        data.forEach(function (dataInstance) {
          var _headObject$ = headObject$1(dataInstance),
              tag = _headObject$.prop,
              x = _headObject$.value;

          var _headObject$2 = headObject$1(omit('label', singleEvaluation)),
              evaluationFunction = _headObject$2.value;

          var label = template(singleEvaluation.label, {
            tag: tag
          });
          test(label, function () {
            evaluationFunction(x);
          });
        });
      });
    });
  } catch (err) {
    console.log(err);
    throw new Error('R.runTestsCatch');
  }
} //https://github.com/staltz/zii


function s() {
  if (Object.prototype.s === undefined) {
    Object.defineProperty(Object.prototype, 's', {
      value: function value(f) {
        return f(this.valueOf());
      },
      writable: true,
      configurable: true
    });
    return true;
  }

  return false;
}

var NO_MATCH_FOUND = Symbol ? Symbol('NO_MATCH_FOUND') : undefined;

var getMatchingKeyValuePair = function getMatchingKeyValuePair(cases, testValue, defaultValue) {
  var iterationValue;

  for (var index = 0; index < cases.length; index++) {
    iterationValue = cases[index].test(testValue);

    if (iterationValue !== NO_MATCH_FOUND) {
      return iterationValue;
    }
  }

  return defaultValue;
};

var isEqual = function isEqual(testValue, matchValue) {
  var willReturn = typeof testValue === 'function' ? testValue(matchValue) : equals(testValue, matchValue);
  return willReturn;
};

var _is = function is(testValue) {
  var matchResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    key: testValue,
    test: function test(matchValue) {
      return isEqual(testValue, matchValue) ? matchResult : NO_MATCH_FOUND;
    }
  };
};

var Switchem = /*#__PURE__*/function () {
  function Switchem(defaultValue, cases, willMatch) {
    _classCallCheck(this, Switchem);

    if (defaultValue !== undefined && cases === undefined && willMatch === undefined) {
      this.cases = [];
      this.defaultValue = undefined;
      this.willMatch = defaultValue;
    } else {
      this.cases = cases;
      this.defaultValue = defaultValue;
      this.willMatch = willMatch;
    }

    return this;
  }

  _createClass(Switchem, [{
    key: "default",
    value: function _default(defaultValue) {
      var holder = new Switchem(defaultValue, this.cases, this.willMatch);
      return holder.match(this.willMatch);
    }
  }, {
    key: "is",
    value: function is(testValue, matchResult) {
      return new Switchem(this.defaultValue, [].concat(_toConsumableArray(this.cases), [_is(testValue, matchResult)]), this.willMatch);
    }
  }, {
    key: "match",
    value: function match(matchValue) {
      return getMatchingKeyValuePair(this.cases, matchValue, this.defaultValue);
    }
  }]);

  return Switchem;
}();

function switcher(input) {
  return new Switchem(input);
}

function tapAsync(fn, input) {
  if (arguments.length === 1) {
    return function (inputHolder) {
      return tapAsync(fn, inputHolder);
    };
  }

  if (isPromise(fn) === true) {
    return new Promise(function (resolve, reject) {
      fn(input).then(function () {
        resolve(input);
      }).catch(reject);
    });
  }

  fn(input);
  return input;
}

function throttle(fn, ms) {
  var wait = false;
  return function () {
    if (!wait) {
      for (var _len25 = arguments.length, input = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
        input[_key25] = arguments[_key25];
      }

      fn.apply(null, input);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, ms);
    }
  };
}

function tryCatch(fn, fallback) {
  if (!isFunction$1(fn)) {
    throw new Error("R.tryCatch | fn '".concat(fn, "'"));
  }

  var passFallback = isFunction$1(fallback);

  if (!isPromise(fn)) {
    return function () {
      try {
        return fn.apply(void 0, arguments);
      } catch (e) {
        return passFallback ? fallback.apply(void 0, arguments) : fallback;
      }
    };
  }

  return function () {
    for (var _len26 = arguments.length, inputs = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      inputs[_key26] = arguments[_key26];
    }

    return new Promise(function (resolve) {
      fn.apply(void 0, inputs).then(resolve).catch(function () {
        if (!passFallback) {
          return resolve(fallback);
        }

        if (!isPromise(fallback)) {
          return resolve(fallback.apply(void 0, inputs));
        }

        fallback.apply(void 0, inputs).then(resolve);
      });
    });
  };
}

function unless(condition, whenFalse) {
  if (arguments.length === 1) {
    return function (whenFalseHolder) {
      return unless(condition, whenFalseHolder);
    };
  }

  return function (input) {
    var flag = typeof condition === 'boolean' ? condition : condition(input);
    if (flag) return input;
    if (isFunction$1(whenFalse)) return whenFalse(input);
    return whenFalse;
  };
}

function wait(fn) {
  return new Promise(function (resolve) {
    fn.then(function (result) {
      return resolve([result]);
    }).catch(function (e) {
      return resolve([, e]);
    });
  });
}

function range(start, end) {
  if (arguments.length === 1) return function (endHolder) {
    return range(start, endHolder);
  };
  var willReturn = [];

  for (var i = start; i < end; i++) {
    willReturn.push(i);
  }

  return willReturn;
}

function waitFor(condition, howLong) {
  var loops = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var typeCondition = type(condition);
  var passPromise = typeCondition === 'Async';
  var passFunction = typeCondition === 'Function';
  var interval = Math.floor(howLong / loops);

  if (!(passPromise || passFunction)) {
    throw new Error('R.waitFor');
  }

  if (passFunction) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _iterator2,
          _step2,
          i,
          resultCondition,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(range(0, loops));
              _context5.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context5.next = 14;
                break;
              }

              i = _step2.value;
              // deepscan-disable-line
              resultCondition = condition.apply(void 0, _args5);

              if (!(resultCondition === false)) {
                _context5.next = 11;
                break;
              }

              _context5.next = 9;
              return delay(interval);

            case 9:
              _context5.next = 12;
              break;

            case 11:
              return _context5.abrupt("return", resultCondition);

            case 12:
              _context5.next = 3;
              break;

            case 14:
              _context5.next = 19;
              break;

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](1);

              _iterator2.e(_context5.t0);

            case 19:
              _context5.prev = 19;

              _iterator2.f();

              return _context5.finish(19);

            case 22:
              return _context5.abrupt("return", false);

            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 16, 19, 22]]);
    }));
  }

  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _iterator3,
        _step3,
        i,
        resultCondition,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _iterator3 = _createForOfIteratorHelper(range(0, loops));
            _context6.prev = 1;

            _iterator3.s();

          case 3:
            if ((_step3 = _iterator3.n()).done) {
              _context6.next = 16;
              break;
            }

            i = _step3.value;
            _context6.next = 7;
            return condition.apply(void 0, _args6);

          case 7:
            resultCondition = _context6.sent;

            if (!(resultCondition === false)) {
              _context6.next = 13;
              break;
            }

            _context6.next = 11;
            return delay(interval);

          case 11:
            _context6.next = 14;
            break;

          case 13:
            return _context6.abrupt("return", resultCondition);

          case 14:
            _context6.next = 3;
            break;

          case 16:
            _context6.next = 21;
            break;

          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](1);

            _iterator3.e(_context6.t0);

          case 21:
            _context6.prev = 21;

            _iterator3.f();

            return _context6.finish(21);

          case 24:
            return _context6.abrupt("return", false);

          case 25:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 18, 21, 24]]);
  }));
}

function when(condition, whenTrue) {
  if (arguments.length === 1) {
    return function (whenTrueHolder) {
      return when(condition, whenTrueHolder);
    };
  }

  return function (input) {
    var flag = typeof condition === 'boolean' ? condition : condition(input);
    if (!flag) return input;
    if (isFunction$1(whenTrue)) return whenTrue(input);
    return whenTrue;
  };
}

function createThenable$1(x) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", x(input));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x9) {
      return _ref16.apply(this, arguments);
    };
  }();
}

function whenAsync(condition, whenTrueFn) {
  if (arguments.length === 1) {
    return function (whenTrueFnHolder) {
      return whenAsync(condition, whenTrueFnHolder);
    };
  }

  return function (input) {
    return new Promise(function (resolve, reject) {
      var whenTrueFnPromise = createThenable$1(whenTrueFn);

      if (typeof condition === 'boolean') {
        if (condition === false) {
          return resolve(input);
        }

        whenTrueFnPromise(input).then(resolve).catch(reject);
      } else {
        var conditionPromise = createThenable$1(condition);
        conditionPromise(input).then(function (conditionResult) {
          if (conditionResult === false) {
            return resolve(input);
          }

          whenTrueFnPromise(input).then(resolve).catch(reject);
        }).catch(reject);
      }
    });
  };
}

function where(conditions, obj) {
  if (obj === undefined) {
    return function (objHolder) {
      return where(conditions, objHolder);
    };
  }

  var flag = true;

  for (var _prop8 in conditions) {
    var result = conditions[_prop8](obj[_prop8]);

    if (flag && result === false) {
      flag = false;
    }
  }

  return flag;
}

function whereEq(rule, input) {
  if (arguments.length === 1) {
    return function (inputHolder) {
      return whereEq(rule, inputHolder);
    };
  }

  if (type(input) !== 'Object') return false;
  var result = filter(function (ruleValue, ruleProp) {
    return equals(ruleValue, input[ruleProp]);
  }, rule);
  return Object.keys(result).length === Object.keys(rule).length;
}

function add(x, y) {
  if (y === undefined) {
    return function (yHolder) {
      return add(x, yHolder);
    };
  }

  return x + y;
}

function adjustRaw(fn, index, arr) {
  var clone = arr.concat();
  return clone.map(function (val, key) {
    if (key === index) {
      return fn(arr[index]);
    }

    return val;
  });
}

var adjust = curry(adjustRaw);

function allPass(conditions, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return allPass(conditions, xHolder);
    };
  }

  return !any(function (condition) {
    return !condition(x);
  }, conditions);
}

function always(x) {
  return function () {
    return x;
  };
}

function anyPass(conditions, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return anyPass(conditions, xHolder);
    };
  }

  return any(function (condition) {
    return condition(x);
  })(conditions);
}

function append(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return append(x, arrHolder);
    };
  }

  if (typeof arr === 'string') return "".concat(arr).concat(x);
  var clone = arr.concat();
  clone.push(x);
  return clone;
}

function assocRaw(prop, value, obj) {
  return Object.assign({}, obj, _defineProperty({}, prop, value));
}

var assoc = curry(assocRaw);

function both(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return both(x, yHolder);
    };
  }

  return function (input) {
    return x(input) && y(input);
  };
}

function complement(fn) {
  return function (input) {
    return !fn(input);
  };
}

function concat(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return concat(x, yHolder);
    };
  }

  return typeof x === 'string' ? "".concat(x).concat(y) : [].concat(_toConsumableArray(x), _toConsumableArray(y));
}

var dec = function dec(x) {
  return x - 1;
};

function flagIs$1(inputArgument) {
  return inputArgument === undefined || inputArgument === null || Number.isNaN(inputArgument) === true;
}

function defaultTo(defaultArgument) {
  for (var _len27 = arguments.length, inputArgument = new Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
    inputArgument[_key27 - 1] = arguments[_key27];
  }

  if (arguments.length === 1) {
    return function (inputArgumentHolder) {
      return defaultTo(defaultArgument, inputArgumentHolder);
    };
  }

  if (arguments.length === 2) {
    return flagIs$1(inputArgument[0]) ? defaultArgument : inputArgument[0];
  }

  var limit = inputArgument.length - 1;
  var len = limit + 1;
  var ready = false;
  var holder;

  while (!ready) {
    var instance = inputArgument[limit - len + 1];

    if (len === 0) {
      ready = true;
    } else if (flagIs$1(instance)) {
      len = len - 1;
    } else {
      holder = instance;
      ready = true;
    }
  }

  return holder === undefined ? defaultArgument : holder;
}

function dissoc(prop, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return dissoc(prop, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return {};
  }

  var willReturn = {};

  for (var p in obj) {
    willReturn[p] = obj[p];
  }

  delete willReturn[prop];
  return willReturn;
}

function divide(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return divide(x, yHolder);
    };
  }

  return x / y;
}

function drop(dropNumber, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return drop(dropNumber, xHolder);
    };
  }

  return x.slice(dropNumber);
}

function dropLast(dropNumber, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return dropLast(dropNumber, xHolder);
    };
  }

  return x.slice(0, -dropNumber);
}

function either(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return either(x, yHolder);
    };
  }

  return function (input) {
    return x(input) || y(input);
  };
}

function endsWith(substr, str) {
  if (arguments.length === 1) {
    return function (strHolder) {
      return endsWith(substr, strHolder);
    };
  }

  return str.endsWith(substr);
}

function F() {
  return false;
}

function find(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return find(fn, arrHolder);
    };
  }

  return arr.find(fn);
}

function findIndex(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return findIndex(fn, arrHolder);
    };
  }

  var len = arr.length;
  var index = -1;

  while (++index < len) {
    if (fn(arr[index], index)) {
      return index;
    }
  }

  return -1;
}

function flatten(arr, willReturn) {
  willReturn = willReturn === undefined ? [] : willReturn;

  for (var i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      flatten(arr[i], willReturn);
    } else {
      willReturn.push(arr[i]);
    }
  }

  return willReturn;
}

function flipExport(fn) {
  return function () {
    for (var _len28 = arguments.length, input = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
      input[_key28] = arguments[_key28];
    }

    if (input.length === 1) {
      return function (holder) {
        return fn(holder, input[0]);
      };
    } else if (input.length === 2) {
      return fn(input[1], input[0]);
    }

    return undefined;
  };
}

function flip(fn) {
  return flipExport(fn);
}

function forEach(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return forEach(fn, arrHolder);
    };
  }

  map(fn, arr);
  return arr;
}

function groupBy(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return groupBy(fn, listHolder);
    };
  }

  var result = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var key = fn(item);

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  }

  return result;
}

function has(prop, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return has(prop, objHolder);
    };
  }

  return obj[prop] !== undefined;
}

function head(a) {
  if (typeof a === 'string') {
    return a[0] || '';
  }

  return a[0];
}

function identity(x) {
  return x;
}

function ifElse(condition, ifFn, elseFn) {
  if (ifFn === undefined) {
    return function (ifFnHolder, elseFnHolder) {
      return ifElse(condition, ifFnHolder, elseFnHolder);
    };
  } else if (elseFn === undefined) {
    return function (elseFnHolder) {
      return ifElse(condition, ifFn, elseFnHolder);
    };
  }

  return function (input) {
    var conditionResult = typeof condition === 'boolean' ? condition : condition(input);

    if (conditionResult === true) {
      return ifFn(input);
    }

    return elseFn(input);
  };
}

var inc = function inc(x) {
  return x + 1;
};

function includes(target, input) {
  if (arguments.length === 1) {
    return function (inputHolder) {
      return includes(target, inputHolder);
    };
  }

  var ok = Array.isArray(input) || typeof input === 'string';
  if (!ok) return false;
  return input.includes(target);
}

function indexBy(fn, list) {
  if (arguments.length === 1) {
    return function (listHolder) {
      return indexBy(fn, listHolder);
    };
  }

  var result = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    result[fn(item)] = item;
  }

  return result;
}

function indexOf(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return indexOf(x, arrHolder);
    };
  }

  var index = -1;
  var length = arr.length;

  while (++index < length) {
    if (arr[index] === x) {
      return index;
    }
  }

  return -1;
}

function is$1(xPrototype, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return is$1(xPrototype, xHolder);
    };
  }

  return x != null && x.constructor === xPrototype || x instanceof xPrototype;
}

function isNil(x) {
  return x === undefined || x === null;
}

function join(glue, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return join(glue, arrHolder);
    };
  }

  return arr.join(glue);
}

function keys(x) {
  return Object.keys(x);
}

function lastIndexOf(x, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return lastIndexOf(x, arrHolder);
    };
  }

  var willReturn = -1;
  arr.map(function (value, key) {
    if (equals(value, x)) {
      willReturn = key;
    }
  });
  return willReturn;
}

function length(x) {
  return x.length;
}

function match(regex, x) {
  if (arguments.length === 1) {
    return function (xHolder) {
      return match(regex, xHolder);
    };
  }

  var willReturn = x.match(regex);
  return willReturn === null ? [] : willReturn;
}

function max(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return max(x, yHolder);
    };
  }

  return y > x ? y : x;
}

function maxBy(fn, x, y) {
  if (arguments.length === 2) {
    return function (yHolder) {
      return maxBy(fn, x, yHolder);
    };
  } else if (arguments.length === 1) {
    return function (xHolder, yHolder) {
      return maxBy(fn, xHolder, yHolder);
    };
  }

  return fn(y) > fn(x) ? y : x;
}

function min(x, y) {
  if (arguments.length === 1) {
    return function (yHolder) {
      return min(x, yHolder);
    };
  }

  return y < x ? y : x;
}

function minBy(fn, x, y) {
  if (arguments.length === 2) {
    return function (yHolder) {
      return minBy(fn, x, yHolder);
    };
  } else if (arguments.length === 1) {
    return function (xHolder, yHolder) {
      return minBy(fn, xHolder, yHolder);
    };
  }

  return fn(y) < fn(x) ? y : x;
}

function modulo(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return modulo(x, yHolder);
  };
  return x % y;
}

function multiply(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return multiply(x, yHolder);
  };
  return x * y;
}

function none(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return none(fn, arrHolder);
  };
  return arr.filter(fn).length === 0;
}

function not(x) {
  return !x;
}

function nth(index, list) {
  if (arguments.length === 1) return function (listHolder) {
    return nth(index, listHolder);
  };
  var idx = index < 0 ? list.length + index : index;
  return Object.prototype.toString.call(list) === '[object String]' ? list.charAt(idx) : list[idx];
}

function partialCurry(fn) {
  var inputArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (inputArgumentsHolder) {
    if (type(fn) === 'Async' || type(fn) === 'Promise') {
      return new Promise(function (resolve, reject) {
        fn(merge(inputArgumentsHolder, inputArguments)).then(resolve).catch(reject);
      });
    }

    return fn(merge(inputArgumentsHolder, inputArguments));
  };
}

function pathOrRaw(defaultValue, inputPath, inputObject) {
  return defaultTo(defaultValue, path(inputPath, inputObject));
}

var pathOr = curry(pathOrRaw);

function pickAll(keys, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return pickAll(keys, objHolder);
    };
  }

  if (obj === null || obj === undefined) {
    return undefined;
  }

  var keysValue = typeof keys === 'string' ? keys.split(',') : keys;
  var willReturn = {};
  var counter = 0;

  while (counter < keysValue.length) {
    if (keysValue[counter] in obj) {
      willReturn[keysValue[counter]] = obj[keysValue[counter]];
    } else {
      willReturn[keysValue[counter]] = undefined;
    }

    counter++;
  }

  return willReturn;
}

function pluck(keyToPluck, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return pluck(keyToPluck, arrHolder);
  };
  var willReturn = [];
  map(function (val) {
    if (!(val[keyToPluck] === undefined)) {
      willReturn.push(val[keyToPluck]);
    }
  }, arr);
  return willReturn;
}

function prepend(x, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return prepend(x, arrHolder);
  };

  if (typeof arr === 'string') {
    return "".concat(x).concat(arr);
  }

  var clone = arr.concat();
  clone.unshift(x);
  return clone;
}

function prop(key, obj) {
  if (arguments.length === 1) return function (objHolder) {
    return prop(key, objHolder);
  };
  return obj[key];
}

function propEq(key, x, obj) {
  if (x === undefined) {
    return function (xHolder, objHolder) {
      return propEq(key, xHolder, objHolder);
    };
  } else if (obj === undefined) {
    return function (objHolder) {
      return propEq(key, x, objHolder);
    };
  }

  return obj[key] === x;
}

function reduce(fn, initialValue, arr) {
  if (initialValue === undefined) {
    return function (initialValueHolder, arrHolder) {
      return reduce(fn, initialValueHolder, arrHolder);
    };
  } else if (arr === undefined) {
    return function (arrHolder) {
      return reduce(fn, initialValue, arrHolder);
    };
  }

  return arr.reduce(fn, initialValue);
}

function reject(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return reject(fn, arrHolder);
  };
  return filter(function (x, i) {
    return !fn(x, i);
  }, arr);
}

function repeat(x, num) {
  if (arguments.length === 1) {
    return function (numHolder) {
      return repeat(x, numHolder);
    };
  }

  var willReturn = Array(num);
  return willReturn.fill(x);
}

function reverse(arr) {
  var clone = arr.concat();
  return clone.reverse();
}

function sortBy(fn, arr) {
  if (arguments.length === 1) {
    return function (arrHolder) {
      return sortBy(fn, arrHolder);
    };
  }

  var arrClone = arr.concat();
  return arrClone.sort(function (a, b) {
    var fnA = fn(a);
    var fnB = fn(b);
    return fnA < fnB ? -1 : fnA > fnB ? 1 : 0;
  });
}

function split(glue, str) {
  if (arguments.length === 1) return function (strHolder) {
    return split(glue, strHolder);
  };
  return str.split(glue);
}

function splitEvery(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return splitEvery(num, xHolder);
  };
  var numValue = num > 1 ? num : 1;
  var willReturn = [];
  var counter = 0;

  while (counter < x.length) {
    willReturn.push(x.slice(counter, counter += numValue));
  }

  return willReturn;
}

function startsWith(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return startsWith(x, yHolder);
  };
  return y.startsWith(x);
}

function subtract(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return subtract(x, yHolder);
  };
  return x - y;
}

function T() {
  return true;
}

function tail(arr) {
  return drop(1, arr);
}

function takeLast(num, x) {
  if (arguments.length === 1) return function (xHolder) {
    return takeLast(num, xHolder);
  };
  var len = x.length;
  var numValue = num > len ? len : num;

  if (typeof x === 'string') {
    return x.slice(len - numValue);
  }

  numValue = len - numValue;
  return baseSlice(x, numValue, len);
}

function tap(fn, x) {
  if (arguments.length === 1) return function (xHolder) {
    return tap(fn, xHolder);
  };
  fn(x);
  return x;
}

function times(fn, num) {
  if (arguments.length === 1) return function (numHolder) {
    return times(fn, numHolder);
  };
  return map(fn, range(0, num));
}

function toString$1(x) {
  return x.toString();
}

function toUpper(x) {
  return x.toUpperCase();
}

function trim(str) {
  return str.trim();
}

function uniq(arr) {
  var index = -1;
  var willReturn = [];

  while (++index < arr.length) {
    var value = arr[index];

    if (!contains(value, willReturn)) {
      willReturn.push(value);
    }
  }

  return willReturn;
}

function uniqWith(fn, arr) {
  if (arguments.length === 1) return function (arrHolder) {
    return uniqWith(fn, arrHolder);
  };
  var index = -1;
  var len = arr.length;
  var willReturn = [];

  var _loop2 = function _loop2() {
    var value = arr[index];
    var flag = any(function (willReturnInstance) {
      return fn(value, willReturnInstance);
    }, willReturn);

    if (!flag) {
      willReturn.push(value);
    }
  };

  while (++index < len) {
    _loop2();
  }

  return willReturn;
}

function update(index, newValue, arr) {
  if (newValue === undefined) {
    return function (newValueHolder, arrHolder) {
      return update(index, newValueHolder, arrHolder);
    };
  } else if (arr === undefined) {
    return function (arrHolder) {
      return update(index, newValue, arrHolder);
    };
  }

  var arrClone = arr.concat();
  return arrClone.fill(newValue, index, index + 1);
}

function values(obj) {
  var willReturn = [];

  for (var key in obj) {
    willReturn.push(obj[key]);
  }

  return willReturn;
}

function without(itemsToOmit, collection) {
  return reduce(function (accum, item) {
    return !contains(item, itemsToOmit) ? accum.concat(item) : accum;
  }, [], collection);
}
/**
 * Taken from 
 * https://github.com/Nozbe/WatermelonDB/blob/master/src/utils/fp/zip/index.js
 */


function zip(left, right) {
  if (right === undefined) {
    return function (right) {
      return zip(left, right);
    };
  }

  var result = [];
  var length = Math.min(left.length, right.length);

  for (var i = 0; i < length; i++) {
    result[i] = [left[i], right[i]];
  }

  return result;
}

function zipObj(x, y) {
  if (arguments.length === 1) return function (yHolder) {
    return zipObj(x, yHolder);
  };
  return x.reduce(function (prev, xInstance, i) {
    prev[xInstance] = y[i];
    return prev;
  }, {});
}

var DELAY = 'RAMBDAX_DELAY';
export { DELAY, ok, complement as opposite, complement, allFalse, allTrue, allType, anyFalse, anyTrue, anyType, change, compact, composeAsync, composed, count, debounce, defaultToStrict, defaultToWhen, delay, findInObject, findModify, flatMap, getter, setter, reset, glue, hasPath, headObject, ifElseAsync, includesAny, includesType, inject, interval, isAttach, isFunction$1 as isFunction, isFalsy, isPromise, isType, isValid, mapAsync, mapFastAsync, mapToObject, maybe, memoize$1 as memoize, mergeAll, mergeRight, mergeDeep, nextIndex, pass, once, otherwise, pathEq, piped, pipedAsync, produce, partition, promiseAllObject, pushUniq, random, remove, renameProps, resolve, runTests, s, shuffle, switcher, tapAsync, template, throttle, tryCatch, unless, wait, waitFor, when, whenAsync, where, whereEq, add, adjust, all, allPass, always, any, anyPass, append, assoc, both, compose, concat, contains, curry, dec, defaultTo, dissoc, divide, drop, dropLast, either, endsWith, equals, F, filter, find, findIndex, flatten, flip, forEach, groupBy, has, head, identity, ifElse, inc, includes, indexBy, indexOf, init, is$1 as is, isNil, join, keys, last, lastIndexOf, length, map, match, merge, max, maxBy, min, minBy, modulo, multiply, none, not, nth, omit, partialCurry, path, pathOr, pick, pickAll, pipe, pluck, prepend, prop, propEq, range, reduce, reject, repeat, replace, reverse, sort, sortBy, split, splitEvery, startsWith, subtract, T, tail, take, takeLast, tap, test$1 as test, times, toLower, toString$1 as toString, toUpper, trim, type, uniq, uniqWith, update, values, without, zip, zipObj };